function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 18");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "path-1",
  points: "7.3264851e-13 17.5638667 156.606444 17.5638667 156.606444 0.1152 7.3264851e-13 0.1152"
}), React.createElement("polygon", {
  id: "path-3",
  points: "0.145488889 0.106933333 16.1930444 0.106933333 16.1930444 17.5555556 0.145488889 17.5555556"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo_architecture",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "HOME-Copy-2",
  transform: "translate(-1640.000000, -800.000000)"
}, React.createElement("g", {
  id: "Group-18",
  transform: "translate(1650.333333, 879.000000) rotate(-270.000000) translate(-1650.333333, -879.000000) translate(1572.000000, 870.000000)"
}, React.createElement("g", {
  id: "Logo-2",
  transform: "translate(0.000000, 0.106933)"
}, React.createElement("path", {
  d: "M27.6795556,8.22397778 C30.1631111,8.22397778 31.2668889,7.16264444 31.2668889,5.40086667 C31.2668889,3.61753333 30.1206667,2.55642222 27.5733333,2.55642222 L21.1411111,2.55642222 L21.1411111,8.22397778 L27.6795556,8.22397778 Z M18.9335556,0.454866667 L27.998,0.454866667 C31.6702222,0.454866667 33.5806667,2.28042222 33.5806667,5.33708889 C33.5806667,7.26864444 32.5828889,8.79708889 30.9484444,9.3702 C32.2644444,9.70997778 32.9226667,10.4953111 33.1562222,12.1722 C33.5168889,14.5497556 33.2408889,15.7382 33.814,17.0544222 L33.814,17.2242 L31.5428889,17.2242 C31.0971111,16.2266444 31.1608889,14.6133111 30.9484444,12.9364222 C30.6513333,10.6226444 30.1631111,10.2193111 27.6795556,10.2193111 L21.1411111,10.2193111 L21.1411111,17.2242 L18.9335556,17.2242 L18.9335556,0.454866667 Z",
  id: "Fill-1",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("polygon", {
  id: "Fill-3",
  fill: "#fff",
  fillRule: "evenodd",
  points: "93.9462667 0.454888889 108.020267 0.454888889 108.020267 2.55644444 96.1538222 2.55644444 96.1538222 7.65088889 107.277156 7.65088889 107.277156 9.70977778 96.1538222 9.70977778 96.1538222 15.1228889 108.126489 15.1228889 108.126489 17.2242222 93.9462667 17.2242222"
}), React.createElement("path", {
  d: "M12.2904444,10.8986667 L8.74555556,2.76866667 L5.20066667,10.8986667 L12.2904444,10.8986667 Z M7.38711111,0.454888889 L10.104,0.454888889 L17.4911111,17.2242222 L15.0497778,17.2242222 L13.2031111,13 L4.28777778,13 L2.44111111,17.2242222 L7.10542736e-13,17.2242222 L7.38711111,0.454888889 Z",
  id: "Fill-5",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M35.2566,8.75457778 C35.2566,3.7028 38.7377111,0.115244444 43.6837111,0.115244444 C47.5257111,0.115244444 50.5188222,2.51391111 51.1130444,6.12235556 L48.7992667,6.12235556 C48.3323778,3.83013333 46.1672667,2.23791111 43.6412667,2.2168 C40.0326,2.19546667 37.5914889,4.80635556 37.5914889,8.64835556 C37.5914889,12.7030222 40.0112667,15.4625778 43.5563778,15.4625778 C46.2946,15.4625778 48.5021556,13.7430222 48.9903778,11.2592444 L51.3041556,11.2592444 C50.6461556,15.0590222 47.4621556,17.5639111 43.7261556,17.5639111 C38.7590444,17.5639111 35.2566,13.9128 35.2566,8.75457778",
  id: "Fill-7",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("polygon", {
  id: "Fill-10",
  fill: "#fff",
  fillRule: "evenodd",
  points: "54.3174667 0.454888889 56.5252444 0.454888889 56.5252444 7.52355556 66.2045778 7.52355556 66.2045778 0.454888889 68.4121333 0.454888889 68.4121333 17.2242222 66.2045778 17.2242222 66.2045778 9.64622222 56.5252444 9.64622222 56.5252444 17.2242222 54.3174667 17.2242222"
}), React.createElement("g", {
  id: "Clip-13"
}), React.createElement("polygon", {
  id: "Fill-12",
  fill: "#fff",
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  points: "72.1473333 17.2243111 74.3548889 17.2243111 74.3548889 0.454977778 72.1473333 0.454977778"
}), React.createElement("polygon", {
  id: "Fill-14",
  fill: "#fff",
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  points: "83.1424444 2.64128889 76.4135556 2.64128889 76.4135556 0.454844444 92.0791111 0.454844444 92.0791111 2.64128889 85.3502222 2.64128889 85.3502222 17.2241778 83.1424444 17.2241778"
}), React.createElement("path", {
  d: "M110.163289,8.75457778 C110.163289,3.7028 113.6444,0.115244444 118.5904,0.115244444 C122.432622,0.115244444 125.425511,2.51391111 126.019733,6.12235556 L123.705956,6.12235556 C123.239067,3.83013333 121.073956,2.23791111 118.547956,2.2168 C114.939289,2.19546667 112.4984,4.80635556 112.4984,8.64835556 C112.4984,12.7030222 114.917956,15.4625778 118.463067,15.4625778 C121.201289,15.4625778 123.408844,13.7430222 123.897289,11.2592444 L126.210844,11.2592444 C125.552844,15.0590222 122.368844,17.5639111 118.632844,17.5639111 C113.665733,17.5639111 110.163289,13.9128 110.163289,8.75457778",
  id: "Fill-15",
  fill: "#fff",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
}), React.createElement("polygon", {
  id: "Fill-16",
  fill: "#fff",
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  points: "133.278733 2.64128889 126.549844 2.64128889 126.549844 0.454844444 142.215178 0.454844444 142.215178 2.64128889 135.486289 2.64128889 135.486289 17.2241778 133.278733 17.2241778"
}), React.createElement("path", {
  d: "M143.127244,11.7053111 L145.568133,11.7053111 C145.653244,14.1037556 147.266578,15.5259778 150.068356,15.5259778 C152.764133,15.5259778 154.271244,14.3373111 154.271244,12.3846444 C154.271244,7.69331111 143.594356,12.1297556 143.594356,4.91264444 C143.594356,2.11064444 146.099022,0.115311111 149.8988,0.115311111 C153.719467,0.115311111 156.394133,2.25908889 156.394133,5.46442222 L154.016578,5.46442222 C153.8468,3.3842 152.361022,2.15308889 149.835022,2.15308889 C147.3088,2.15308889 145.907911,3.25686667 145.907911,5.14597778 C145.907911,9.60375556 156.606356,5.37953333 156.606356,12.3846444 C156.606356,15.3564222 154.229022,17.5637556 149.983689,17.5637556 C145.8868,17.5637556 143.127244,15.3986444 143.127244,11.7053111",
  id: "Fill-17",
  fill: "#fff",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
})), React.createElement("g", {
  id: "Group-9",
  transform: "translate(35.111111, 0.115244)"
}, React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("g", {
  id: "Clip-8"
})))));

var SvgLogoArchitectsVertical = function SvgLogoArchitectsVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "158px",
    viewBox: "0 0 20 158",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoArchitectsVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_architects_vertical.caf21a41.svg";
export { ForwardRef as ReactComponent };